export default __webpack_public_path__ + "static/media/phone3.2d4cc5ef.png";